export default {"src":"/_next/static/media/dots.c95b4083.svg","height":49,"width":50,"blurWidth":0,"blurHeight":0};